import { withTranslation } from "react-i18next";
import EditableText from './EditableText'
import './EditableText.less'
export default withTranslation()(EditableText);